import { useParams } from "react-router";
import { useMemo } from "react";

import { useFetchEscalationsQuery } from "../services/api/escalationApi/escalation";

import { initialState } from "./useEscalations";

// ID override when getting this escalation outside of the escalation page
export function useCurrentEscalation(idOverride?: number) {
  const { escalationId: escalationIdParam, organisationId } = useParams<{ escalationId?: string; organisationId: string }>();
  const escalationId = idOverride ?? (escalationIdParam ? Number(escalationIdParam) : undefined);

  // Same params (and therefore cache entry) as `useEscalationParams` builds on the escalation page
  const { data: escalationsData, isLoading } = useFetchEscalationsQuery({
    ...initialState,
    includePaid: true,
    organisationId,
    escalationId,
  }, {
    skip: !organisationId || !escalationId,
    refetchOnMountOrArgChange: true,
    pollingInterval: 1000 * 60, // 60 seconds
    skipPollingIfUnfocused: true,
  });

  const currentEscalation = useMemo(() => {
    if (!escalationsData || !escalationsData.escalations) {
      return null;
    }

    return escalationsData.escalations.find(escalation => escalation.id === escalationId);
  }, [escalationId, escalationsData]);

  return { currentEscalation, isLoading };
}
